import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';

export default class Page {
    constructor() {
        // Page

        const sliders = document.querySelectorAll('.wp-block-gallery');
        if (sliders.length > 0) {
            sliders.forEach((elt) => {
                this.slider(elt);
            });
        }
    }

    slider(elt) {
        const slider = tns({
            container: elt,
            items: 1,
            slideBy: 'page',
            autoplay: false,
            nav: false,
            controlsText: ['', ''],
        });

        const slides = slider.getInfo().slideItems;
        const parentElement = elt.parentElement.parentElement.parentElement;
        if (slides.length > 0) {
            Array.from(slides).forEach((slide) => {
                slide.addEventListener('click', () => {
                    if (!parentElement.classList.contains('js-fullWidth')) {
                        parentElement.classList.add('js-fullWidth');
                    }
                });
            });
        }

        const overlay = parentElement.querySelector('.tns-liveregion');
        if (overlay) {
            overlay.addEventListener('click', () => {
                parentElement.classList.remove('js-fullWidth');
            });
        }
    }
}